"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const styles_1 = require("@mui/material/styles");
const accounts_1 = require("companion-app-components/flux/accounts");
const core_1 = require("companion-app-components/utils/core");
const monthlyBarChart_1 = __importDefault(require("containers/Reports/components/monthlyBarChart"));
const utils_1 = require("components/QCurrency/utils");
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const LoadingView_1 = __importDefault(require("components/LoadingView"));
const config_1 = require("components/SpendingWithRegister/config");
const selectors_1 = require("data/otReports/selectors");
const utils_2 = require("utils/date/utils");
const net_income_svg_1 = __importDefault(require("assets/nav-menu/net-income.svg"));
const helpers_1 = require("../helpers");
const styles = (_theme) => ({
    root: {
        height: '100%',
    },
});
const useStyles = (0, mui_1.makeStyles)()(styles);
const NetIncomeOverview = () => {
    const { classes } = useStyles();
    const theme = (0, styles_1.useTheme)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const hasReportableAccounts = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getHasReportableAccounts(state));
    const dateInterval = (0, utils_2.getPredefinedRange)({ value: '6_MONTHS' });
    const incomeForPeriods = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getIncomeForPeriods)(state, { dateInterval }));
    const spendingForPeriods = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getSpendingForPeriods)(state, { dateInterval }));
    const [selectedMonthIndex, setSelectedMonthIndex] = React.useState(null);
    const getCurrency = (incomeCurrency, spendingCurrency) => (0, utils_1.getCombinedCurrency)(incomeCurrency, spendingCurrency);
    const dataIsNull = () => incomeForPeriods === null || spendingForPeriods === null;
    const dataIsEmpty = () => !dataIsNull() && (incomeForPeriods.txns.size === 0 && spendingForPeriods.txns.size === 0);
    const combineSpendingAndIncome = () => {
        const incomeByPeriods = incomeForPeriods.periods;
        const spendingByPeriods = spendingForPeriods.periods;
        const combinedData = [];
        for (let i = 0; i < incomeByPeriods.size; i++) {
            combinedData.push({
                amount: -(incomeByPeriods.get(i).amount + spendingByPeriods.get(i).amount),
                currency: getCurrency(incomeByPeriods.get(i).period.currency, spendingByPeriods.get(i).currency),
                label: incomeByPeriods.get(i).period.monthLong,
                period: incomeByPeriods.get(i).period,
                shortLabel: incomeByPeriods.get(i).period.monthShort,
                year: incomeByPeriods.get(i).period.year,
                txns: spendingByPeriods.get(i).txns.concat(incomeByPeriods.get(i).txns),
            });
        }
        return combinedData;
    };
    const navigateToNetIncome = (e) => {
        e.stopPropagation();
        navigate(`/net-income?selectTab=${config_1.BY_MONTH}`);
    };
    const navigateToNetIncomeWithMonth = (index) => {
        navigate(`/reports/net-income/over-time${index !== null ? `?selectMonth=${index}` : ''}`);
    };
    const onBarGraphClick = (indexOfClickedMonth) => {
        if (indexOfClickedMonth === 0 || indexOfClickedMonth) {
            core_1.tracker.track(core_1.tracker.events.barSelected, { chart: 'spending' });
            setSelectedMonthIndex(indexOfClickedMonth);
            setTimeout(() => { navigateToNetIncomeWithMonth(indexOfClickedMonth); }, 1000);
        }
        return true;
    };
    const view = (0, helpers_1.computeViewState)(dataIsNull, dataIsEmpty, hasReportableAccounts);
    // todo: after fixing render issues (props always invalid and always calling render), remove or move to trace
    // log.debug('NetIncomePage.render...', this.props);
    let combinedData;
    if (view === 'main') {
        combinedData = combineSpendingAndIncome();
    }
    return (<>
      {view === 'loading' &&
            <LoadingView_1.default />}
      {view === 'zero' &&
            <ZeroStateView_1.default icon={net_income_svg_1.default} size="small" secondary={['Sync your financial institutions to ', <br key="br"/>, 'see your net income over time.']}/>}
      {view === 'empty' &&
            <ZeroStateView_1.default size="small" icon={net_income_svg_1.default} primary="No Income" secondary="It looks like you haven't spent or made any money in the last 6 months."/>}
      {view === 'main' &&
            <div className={classes.root} onClick={navigateToNetIncome} onKeyPress={navigateToNetIncome} role="presentation">
        <monthlyBarChart_1.default idPrefix="net-income" negator={-1} monthlyData={combinedData} active selectedMonthIndex={selectedMonthIndex} onBarGraphClick={onBarGraphClick} navigateToReports={navigateToNetIncome} tooltipLabel="Income" getBarAmount={(amount) => -amount} expandableGrid={false} isDashboard colors={{
                    positiveDefault: theme.components.netIncome.positiveDefault,
                    positiveDimmed: theme.components.netIncome.positiveDimmed,
                    negativeDefault: theme.components.netIncome.negativeDefault,
                    negativeDimmed: theme.components.netIncome.negativeDimmed,
                    tooltipBullet: theme.components.netIncome.positiveDefault,
                }}/>
      </div>}
    </>);
};
exports.default = NetIncomeOverview;
